import { ValidationError, mixed, object } from 'yup'
import {
  LOAD_ECCENTRICITY_MISSING_MESSAGE,
  getMissingLoadEccentricityAxes,
} from '@editor/components/CheckSettingsFormFields/LoadEccentricityFormFields/utils'

/**
 * Validates the Lastexzentrizität multi-edit form. `elements` and `sharedSettings`
 * stay `mixed()` so yup never strips the live-preview data; an emptied
 * eccentricity is marked on its field.
 */
export const loadEccentricityMultiEditSchema = object({
  elements: mixed(),
  sharedSettings: mixed().test('load-eccentricity-complete', '', function (value) {
    const missingAxes = getMissingLoadEccentricityAxes(value as SettingsOnMember | undefined)
    if (!missingAxes.length) return true
    return new ValidationError(
      missingAxes.map(axis =>
        this.createError({
          path: `${this.path}.load_eccentricity.${axis}`,
          message: LOAD_ECCENTRICITY_MISSING_MESSAGE,
        }),
      ),
    )
  }),
})
